import { useState, useEffect } from "react";
export function AccommodationsCard({ data, selectSailing, selectSailingBack, sailingSelected, sailingSelectedBack, sailingData, way, selectedSailing}) {

  const formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  

  });

  const [selected, setSelected] = useState(false);
  const [price, setPrice] = useState(formatter.format(setIniticalPrice(data.tariffs[0])));
  const [realPrice, setRealPrice] = useState(formatter.format(data.tariffs[0].price));

  const [selectedTariff, setSelectedTariff] = useState(null);

  function tariffs() {
    return data.tariffs.map((element, index) => <option value={index}>{element.name} </option>)
  }

  function setIniticalPrice(price) {
    if (price.discounted_price == null) {
      return price.price;
    } else {
      return price.discounted_price;
    }
  }
  
  const handleChange = event => {
    const index = event.target.value;
    var price
    if (data.tariffs[index].discounted_price == null) {
      price = formatter.format(data.tariffs[index].price);
    }else{
      price = formatter.format(data.tariffs[index].discounted_price);
    }

    setPrice(price);
    setRealPrice(formatter.format(data.tariffs[index].price));
    setSelectedTariff(data.tariffs[index]);

  };

  const handleButtonSelectBack = () => {
    setSelected(true)
    var dataToSend;
    if (!selectedTariff) {
      dataToSend = {
        ...data,
        tariff: data.tariffs[0],
        sailingData: sailingData,}
      } else {
      dataToSend = {
        data,
        tariff: selectedTariff,
        sailingData: sailingData,
      }

    }
    selectSailingBack(dataToSend);
  }

  const handleButtonSelect = () => {
    setSelected(true)
    var dataToSend;
    if (!selectedTariff) {
      dataToSend = {
        ...data,
        tariff: data.tariffs[0],
        sailingData: sailingData,}
      } else {
      dataToSend = {
        data,
        tariff: selectedTariff,
        sailingData: sailingData,
      }

    }

    selectSailing(dataToSend);
  }

  const handleButtonUnselect = () => {
    setSelected(false)
    selectSailing(null);
  }

  const showButton = (acco_name) => {
    if(way==="go") {
      if (selected) {
        return <div className="btnBlue-m noMargin select_go" id="unselect_button" onClick={handleButtonUnselect}  >Quitar </div>
        
      } else if (sailingSelected) {
        
      } else {

        return <div className="btnOrange-m noMargin select_go" id="select_button" onClick={handleButtonSelect}  >Elegir</div>
      }
    } else {
      if(selectedSailing) {
        if(selected){
          return <div className="btnBlue-m noMargin select_go" id="unselect_button" onClick={handleButtonUnselect}  >Quitar </div>
        }else if(selectedSailing["name"]!= acco_name){
          // elegida alguna otra vuelta
        }else if(sailingSelectedBack){
          // elegida la vuelta
        }else{
          return <div className="btnOrange-m noMargin select_go" id="select_button" onClick={handleButtonSelectBack}  >Elegir</div>
        }
      }else{
        
      }
    }
  }
  
  return (
    <>
          <div className="row">
            <div className="cardBill loopX3">
              <div className="cardBill__acomodacion">{data.name}</div>
              <div className="cardBill__select">
                <div className="m-frmGroup">
                  <select  className="go[0-0]" id="choose" onChange={handleChange}>
                    {tariffs()}
                  </select>
                </div>
              </div>
     
              <div id="" className="cardBill__priceBut">
                <div className="priceAndButton">
                  <span className="price ht-four-bold"> {price}</span>
                  
                  
                  {showButton(data.name)}
                </div>
              </div>
            </div>
          </div>
    </>
  );
}
